export enum ImportUploadTile {
  file = 'file',
  list = 'list',
}

export type ImportUploadStage = 'uploading' | 'processing'
